/* eslint-disable no-useless-escape */
import React, { useState } from 'react';
import '../../css/Login.css';
import ApiGateway from '../../helper/ApiGateway';
import Loader from '../../helper/Loader';
import Popup from '../../helper/SuccessPopup';
import ERPUtils from '../../helper/Utils';
import Warning from "../../images/warning.png";
import Correct from "../../images/correct.svg";

const ChangePassword = (props) => {
	const { close, registrationId ,Logged,LogMeOut} = props;

	const [LoaderActive, setLoaderActive] = useState(false);
	const [ErrorMsg, setErrorMsg] = useState('');
	const [ErrorPopup, setErrorPopup] = useState(false);
	const [details, setDetails] = useState({
		oldPassword: '',
		newPassword: '',
		confirmNewPassword: ''
	});
	const [NewPasswordError, setNewPasswordError] = useState(false);
	const [passwordError, setPasswordError] = useState(false);
	// const [passErrorPopup, setPassErrorPopup] = useState(false);
	const [changeSuccess, setChangeSuccess] = useState(false);
	// required Fields:
	const [requiredFields, setRequiredFields] = useState({
		oldPasswordReqError: false,
		newPasswordReqError: false,
		confirmPasswordReqError: false
	});

	const onChangeHandler = (event) => {
		const name = event.target.name;
		const val = event.target.value;
		const oldData = { ...details };
		oldData[name] = val;
		if (name === 'newPassword') {
			if (NewPasswordError) {
				setNewPasswordError(false);
			}
			oldData.confirmNewPassword = ""
		}
		setDetails(oldData);
		if (name === 'confirmNewPassword' && passwordError) {
			setPasswordError(false);
		}
		if (ERPUtils.isNullorWhiteSpace(val) === false) {
			removeRequiredFields(name);
		}
	};

	const removeRequiredFields = (name) => {
		const oldData = { ...requiredFields };
		if (name === 'oldPassword') {
			oldData['oldPasswordReqError'] = false;
		}
		if (name === 'newPassword') {
			oldData['newPasswordReqError'] = false;
		}
		if (name === 'confirmNewPassword') {
			oldData['confirmNewPasswordReqError'] = false;
		}
		setRequiredFields(oldData);
	};

	const CheckRequiredFields = () => {
		const oldData = { ...requiredFields };
		if (ERPUtils.isNullorWhiteSpace(details.oldPassword)) {
			oldData['oldPasswordReqError'] = true;
		}
		if (ERPUtils.isNullorWhiteSpace(details.newPassword)) {
			oldData['newPasswordReqError'] = true;
		}
		if (ERPUtils.isNullorWhiteSpace(details.confirmNewPassword)) {
			oldData['confirmNewPasswordReqError'] = true;
		}
		checkForRequiredErrors(oldData);
	};

	const checkForRequiredErrors = (data) => {
		let validationErrorsFound = [];
		Object.keys(data).map((el) => {
			validationErrorsFound.push(data[el]);
			return '';
		});
		if (validationErrorsFound.indexOf(true) !== -1) {
			setRequiredFields(data);
		} else {
			setRequiredFields(data);
			checkpassword();
		}
		return '';
	};

	const checkpassword = () => {
		const passwordCheck = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
		if (details.newPassword.match(passwordCheck)) {
			setNewPasswordError(false);
			comparePasswords();
		} else {
			setNewPasswordError(true);
		}
	};

	const comparePasswords = () => {
		if (details.newPassword === details.confirmNewPassword) {
			ChangePassApi();
		} else {
			setPasswordError(true);
			// setPassErrorPopup(true);
		}
	};

	const AlertError = () => {
		setErrorPopup(true);
	};

	const ErrorPopupHandler = () => {
		setErrorPopup(!ErrorPopup);
	};

	const closeReqFieldAlert = (name) => {
		// if (name === 'password') {
		// 	setPassErrorPopup(false);
		// }
		if (name === 'changeSuccess') {
			setChangeSuccess(false);
			if(Logged){
				LogMeOut()
			}
			close();
		}
		return '';
	};

	const ChangePassApi = () => {
		// var id = sessionStorage.getItem('RegistrationId');
		var id = !ERPUtils.isNullorWhiteSpace(registrationId)?registrationId:sessionStorage.getItem('registrationID')
		setLoaderActive(true);
		ApiGateway.post(
			'ApplicantSecurity/changePassword',
			{ existingPwd: details.oldPassword, newPwd: details.newPassword, empApplicationRegistrationId: id },
			(response) => {
				try {
					setLoaderActive(false);
					if (ERPUtils.isUndefinedOrNull(response.data) === false) {
						if (response.data.success === false) {
							setErrorMsg(response.data.failureMessage);
							AlertError();
						} else {
							if (response.data.failureMessage === null) {
								setChangeSuccess(true);
							} else {
								setErrorMsg(response.data.failureMessage);
								AlertError();
							}
						}
					} else {
						setErrorMsg('An Error! occurred, Please try again');
						AlertError();
					}
				} catch (ex) {
					setLoaderActive(false);
				} finally {
					setLoaderActive(false);
				}
			}, "Public"
		);
	};

	const showPassWord = (name, target) => {
		var temp = document.getElementById(target);
		if (temp.type === 'password') {
			temp.type = 'text';
			document.getElementById(name).classList.add('fa-eye-slash');
		} else {
			temp.type = 'password';
			document.getElementById(name).classList.remove('fa-eye-slash');
		}
	};

	// password added methods and states

	const [violetRule, setVioletRule] = useState({
		isSmallAndCap: false,
		isNumOrSpecial: false,
		valideLength: false
	})

	const [disableConfirmPassword, setDisableConfirmPassword] = useState(true);

	const checkCaseOfString = (string) => {
		const
			upper = /[A-Z]/.test(string),
			lower = /[a-z]/.test(string);

		return upper && lower;
	}
	const checkCaseOfNum = (string) => {
		const
			number = /[0-9]/.test(string),
			specialChar = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(string);

		return number && specialChar;
	}

	const validatePassword = (string) => {
		const isCapitalAndSmallRule = checkCaseOfString(string);
		const isValidNumOrSpecialCase = checkCaseOfNum(string);
		const validLength = string.length > 8;
		const ruleErrorsObj = { ...violetRule }

		if (isCapitalAndSmallRule && isValidNumOrSpecialCase && validLength) {
			setDisableConfirmPassword(false)
			ruleErrorsObj["isSmallAndCap"] = false
			ruleErrorsObj["isNumOrSpecial"] = false
			ruleErrorsObj["valideLength"] = false
		} else {
			setDisableConfirmPassword(true);
			if (!isCapitalAndSmallRule) ruleErrorsObj["isSmallAndCap"] = true;
			else ruleErrorsObj["isSmallAndCap"] = false;
			if (!isValidNumOrSpecialCase) ruleErrorsObj["isNumOrSpecial"] = true;
			else ruleErrorsObj["isNumOrSpecial"] = false;
			if (!validLength) ruleErrorsObj["valideLength"] = true;
			else ruleErrorsObj["valideLength"] = false;
		}

		setVioletRule(ruleErrorsObj);
	}

	const comparePaswordONBlur = () => {
		if (!ERPUtils.isNullorWhiteSpace(details.confirmNewPassword) && !ERPUtils.isNullOrEmpty(details.confirmNewPassword)) {
			if (details.newPassword !== details.confirmNewPassword) {
				setPasswordError(true);
			}
		} else {
			setPasswordError(false);
		}
	}

	return (
		<div className="card employee-application-card-style-1">
			<div>
				<div className="formHeader">
					<h3 className="headTypo">
						Change password
						<button type="button" className="removeButton" onClick={close}>
							&times;
						</button>
					</h3>
				</div>
				<div className="formBody">
					<div className="form-group has-feedback formWrapper">
						<label className="formlabel">
							Current Password
						</label>
						<span className="loginsRequiredText">*</span>
						<input
							className="form-control input"
							onChange={onChangeHandler}
							name="oldPassword"
							type="password"
							autoComplete="off"
							value={details.oldPassword}
							id="changeOldPassword"
						/>
						<span
							className="fa fa-eye field-icon"
							id="changeOldPasscode"
							onClick={showPassWord.bind(this, 'changeOldPasscode', 'changeOldPassword')}
						/>
						{requiredFields.oldPasswordReqError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Please enter your current password
							</p>
						) : null}
					</div>
					<div className="form-group has-feedback formWrapper">
						<label className="formlabel">
							New Password
						</label>
						<span className="loginsRequiredText">*</span>
						<input
							className="form-control input"
							onChange={onChangeHandler}
							name="newPassword"
							type="password"
							autoComplete="off"
							value={details.newPassword}
							id="changeNewPassword"
							onBlur={() => validatePassword(details.newPassword)}
						/>
						<span
							className="fa fa-eye field-icon"
							id="changeNewPasscode"
							onClick={showPassWord.bind(this, 'changeNewPasscode', 'changeNewPassword')}
						/>
						{requiredFields.newPasswordReqError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Please enter your new password
							</p>
						) : null}

						{/* {details.newPassword.length > 0 ? ( */}
						<p className='px-2  m-0'>
							{checkCaseOfString(details.newPassword) ?
								<img src={Correct} alt="correct" width="15" height="15" />
								: <img src={Warning} alt="warning" width="15" height="15" />
							}
							<span className='pl-1'
								style={{ fontSize: "12px", color: (violetRule.isSmallAndCap && !checkCaseOfString(details.newPassword)) ? "red" : "inherit" }}
							>
								Includes both Capital and Small Letters</span>
						</p>
						<p className='px-2  m-0'>
							{checkCaseOfNum(details.newPassword) ?
								<img src={Correct} alt="correct" width="15" height="15" />
								: <img src={Warning} alt="warning" width="15" height="15" />
							}
							<span className='pl-1'
								style={{ fontSize: "12px", color: (violetRule.isNumOrSpecial && !checkCaseOfNum(details.newPassword)) ? "red" : "inherit" }}
							>
								Includes Numerical and Special characters</span>
						</p>
						<p className='px-2  m-0'>
							{details.newPassword?.length > 8 ?
								<img src={Correct} alt="correct" width="15" height="15" />
								: <img src={Warning} alt="warning" width="15" height="15" />
							}
							<span className='pl-1'
								style={{ fontSize: "12px", color: (violetRule.valideLength && !(details.newPassword?.length > 8)) ? "red" : "inherit" }}
							>Includes more than 8 characters</span>
						</p>
						{/* ) : null} */}
					</div>
					<div className="form-group has-feedback formWrapper">
						<label className="formlabel">
							Confirm New Password
						</label>
						<span className="loginsRequiredText">*</span>
						<input
							className="form-control input"
							onChange={onChangeHandler}
							name="confirmNewPassword"
							type="password"
							autoComplete="off"
							value={details.confirmNewPassword}
							id="changeConfirmPassword"
							disabled={disableConfirmPassword}
							onBlur={comparePaswordONBlur}
						/>
						<span
							className="fa fa-eye field-icon"
							id="changeConfirmPasscode"
							onClick={showPassWord.bind(this, 'changeConfirmPasscode', 'changeConfirmPassword')}
						/>
						{requiredFields.confirmNewPasswordReqError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Please confirm your new password
							</p>
						) : null}
						{passwordError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" /> Passwords are not matching
							</p>
						) : null}
					</div>
				</div>

				<div className="formFooter">
					<button className="ContinueButton" onClick={CheckRequiredFields}>
						Change my password
					</button>
					<br />
				</div>
			</div>
			{ErrorPopup ? (
				<Popup
					open={ErrorPopup}
					close={ErrorPopupHandler}
					msg={ErrorMsg}
					icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
					title="Sorry!"
					success={false}
				/>
			) : null}
			{LoaderActive ? <Loader open={LoaderActive} LoaderType={1} /> : null}
			{/* {passErrorPopup ? (
				<Popup
					open={passErrorPopup}
					close={closeReqFieldAlert}
					msg="Please make sure that your new password and confirm password matches."
					title="Error!"
					icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
					success={false}
					hint="Note: Please review your form and submit"
					tabName="password"
				/>
			) : null} */}
			{changeSuccess ? (
				<Popup
					open={changeSuccess}
					close={closeReqFieldAlert}
					msg={Logged ? "Your password has been changed successfully , Please login again ":"Your password has been changed successfully"}
					title="Success!"
					icon={<i className="fa fa-check successIcon" aria-hidden="true" />}
					success={true}
					tabName="changeSuccess"
				/>
			) : null}
		</div>
	);
};

export default ChangePassword;
